import { render, staticRenderFns } from "./OrderComplete.vue?vue&type=template&id=3c6b36d8&"
import script from "./OrderComplete.vue?vue&type=script&lang=js&"
export * from "./OrderComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports